import {
  SERVICES,
  BUILDING_COMPLEXES,
  EMPLOYEES,
  REGIONS,
  SKILLS
} from '../common/schedule-filters';

export default {
  day: undefined,
  order: null,
  currentTask: {},
  tasks: [],
  tasksDate: [],
  ordersList: [],
  reasonsList: [],
  reiterationsList: [],
  taskStatuses: [],
  employeesList: [],
  servicesList: [],
  selectedDay: null,
  selectedEntity: null,
  filters: {
    [SERVICES]: [],
    [BUILDING_COMPLEXES]: [],
    [EMPLOYEES]: [],
    [REGIONS]: [],
    [SKILLS]: []
  },
  snacks: [],
  employeesRequestedVacations: [],
  isMultiTaskUpdate: false
};
